function initWishlist() {
    
        setLocalStorageProductForWishlist();

        document.addEventListener('click', (event) => {
            const target = event.target.closest('[data-wishlist]');
            if (!target) return;

            event.preventDefault();
            event.stopPropagation();

            if (!target.classList.contains('is-in-grid')) {
                document.querySelectorAll('[data-wishlist-items-display]').forEach(item => {
                    item.classList.remove('is-loaded');
                });
            }

            const id = target.getAttribute('data-product-id');
            const handle = target.getAttribute('data-wishlist-handle');
            let wishlistList = JSON.parse(localStorage.getItem('wishlistItem')) || [];
            const index = wishlistList.indexOf(handle);
            const wishlistContainer = document.querySelector('[data-wishlist-container]');
            const wishlistLayout = wishlistContainer ? wishlistContainer.getAttribute('data-wishlist-layout') : null;

            if (!target.classList.contains('wishlist-added')) {
                target.classList.add('wishlist-added');
                //target.querySelector('.text').textContent = window.wishlist.added;

                if (wishlistContainer) {
                    const addEvent = new CustomEvent('addwishlistitem', { detail: { handle }, bubbles: true });
                    document.dispatchEvent(addEvent);
                }

                wishlistList.push(handle);
                localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));

                const updateWishlistMailEvent = new CustomEvent('updatewishlistmail', { bubbles: true });
                document.dispatchEvent(updateWishlistMailEvent);
            } else {
                target.classList.remove('wishlist-added');
                //target.querySelector('.text').textContent = window.wishlist.add;

                if (wishlistContainer) {
                    const wishlistAddedElem = document.querySelector(`[data-wishlist-added="wishlist-${id}"]`);
                    if (wishlistAddedElem) {
                        wishlistAddedElem.remove();
                        const icon = document.querySelector(`[data-wishlist][data-product-id="${id}"]`);
                        const productCard = icon.closest('.product');
                        if (productCard) productCard.remove();
                    }
                }

                wishlistList.splice(index, 1);
                localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));

                const updatePaginationEvent = new CustomEvent('updatepagination', { bubbles: true });
                document.dispatchEvent(updatePaginationEvent);

                if (wishlistContainer) {
                    wishlistList = JSON.parse(localStorage.getItem('wishlistItem')) || [];

                    if (wishlistList.length > 0) {
                        const updateWishlistMailEvent = new Event('updatewishlistmail', { bubbles: true });
                        document.dispatchEvent(updateWishlistMailEvent);
                    } else {
                        wishlistContainer.classList.add('is-empty');
                        wishlistContainer.innerHTML = `
                            <div class="wishlist__content-empty text-center">
                                <span class="wishlist__content-text">${window.wishlist.empty}</span>
                                <div class="wishlist__content-actions">
                                    <a class="wishlist__button-continue" href="${window.routees.collection_all}">
                                        ${window.wishlist.continue_shopping}
                                    </a>
                                </div>
                            </div>
                        `;
                        document.querySelector('[data-wishlist-footer]').style.display = 'none';
                    }
                }
            }

            //document.querySelector('[data-wishlist-count]').textContent = wishlistList.length;
            setProductForWishlist(handle);
          
        });
   
}
initWishlist()


function setProductForWishlist(handle) {
    const wishlistList = JSON.parse(localStorage.getItem('wishlistItem'));
    const item = document.querySelectorAll(`[data-wishlist-handle="${handle}"]`);
    const index = wishlistList?.indexOf(handle);

    if (index == null || wishlistList == null) return;

    item.forEach(el => {
        const textElement = el.querySelector('.text');
        if (index >= 0) {
            el.classList.add('wishlist-added');
            if (textElement) textElement.textContent = window.wishlist.added;
        } else {
            el.classList.remove('wishlist-added');
            if (textElement) textElement.textContent = window.wishlist.add;
        }
    });
}

function setLocalStorageProductForWishlist() {
    let wishlistList = localStorage.getItem('wishlistItem') 
        ? JSON.parse(localStorage.getItem('wishlistItem')) 
        : [];
    localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));

    if (wishlistList.length > 0) {
        wishlistList.forEach((handle) => {
            setProductForWishlist(handle);
        });
    }

    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
        el.textContent = wishlistList.length;
    });
}